import {types} from 'mobx-state-tree';

const SortItem = types.model('SortItem', {
    name: types.string,
    direction: types.optional(types.enumeration('SortDirection', ['+', '-']), '-'),
});
export default SortItem;
